import Core from '../../../Core/Core';
import { PopupActions } from '../../../State/Actions/Actions';
import { createPixiText } from '../../../Utils/Utils';
import { PlayerAvatarFrame } from '../../Map/PlayerAvatarFrame';
import { BaseRewardPopup } from './BaseRewardPopup';

export class FriendJoinedPopup extends BaseRewardPopup {
    constructor(width: number, height: number, friendAvatar: string, friendName: string) {
        super(width, height, Core.local.getText('friendjoined'), Core.local.getText('collect'));

        const avatar = new PlayerAvatarFrame(friendAvatar, false);
        avatar.x = this.innerWidth / 2;
        avatar.y = this.innerHeight * 0.435;
        this.main.addChild(avatar);

        const avatarCoins = new PIXI.Sprite(
            PIXI.utils.TextureCache['mapui/leaderboard-friend-joined-frame']
        );
        avatarCoins.anchor.set(0.5);
        avatarCoins.x = this.innerWidth / 2;
        avatarCoins.y = this.innerHeight * 0.45;
        this.main.addChild(avatarCoins);

        const messageText = createPixiText(
            Core.local.getText('invitethanks').replace('/player name/', friendName),
            new PIXI.Rectangle(
                this.innerWidth / 2,
                this.innerHeight * 0.5,
                this.innerWidth * 0.9,
                height * 0.2
            ),
            'Baloo',
            35,
            30
        );
        messageText.anchor.set(0.5);
        messageText.position.set(this.innerWidth / 2, this.innerHeight * 0.7);
        this.main.addChild(messageText);
    }

    protected emitPopupCloseAction(): void {
        this.emit(PopupActions.FRIENDJOINED_POPUP_CLOSE, 'close');
    }
}
